// extracted by mini-css-extract-plugin
export var details = "styles-module--details--b9122";
export var map = "styles-module--map--5f97e";
export var title = "styles-module--title--b3106";
export var wrapper = "styles-module--wrapper--fa2f5";